import logo from "../assets/ladyjustice-backgroubd-removed.png";

function Loader() {
  return (
    <div className="fixed inset-0 bg-[#0B3D91] flex items-center justify-center z-50">
      
      <div className="text-center">
        <img
          src={logo}
          alt="Logo"
          className="w-24 mx-auto animate-pulse"
        />
        <p className="text-white mt-4 text-sm tracking-wide">
          Loading...
        </p>
      </div>

    </div>
  );
}

export default Loader;